import { useReducer, useEffect, useCallback, useRef } from 'react';
import { CreditUserReducer } from './CreditUserReducer';
import { CreditUserContext } from './CreditUserContext';
import { UPDATE_CREDIT_USER, UPDATE_DATOS_VARIOS, UPDATE_DEUDA_HOY_BACKEND } from './types';
import { calcularFechas } from '../../components/credits/calculoFechas';
import { getInterest } from '../../utils/creditUser/getInterest';
import moment from 'moment';

export const CreditUserState = (props) => {

    const calcularTotalAPagar = useCallback((vence, tasa) => {
        const Amount = 200000;
        const tasaDecimal = tasa ? parseFloat(tasa) / 100 : 0;
        const interest = Math.round(Amount * tasaDecimal * vence);
        const admon = 60000;
        //Calcular IVA
        const iva = Math.round(admon * (19 / 100));
        //Calcular Total
        const total = Math.round(Amount + interest + admon + iva);
        return total;
    }, []);

    const fechasOptions = calcularFechas();
    const dateLimit2 = fechasOptions.fecha2.format("DD/MM/YYYY");
    const vence2 = fechasOptions.fecha2.diff(moment(), "days") + 1;

    // Usar tasa cacheada del mes actual si está disponible, o 0 mientras carga
    const cachedTed = localStorage.getItem("currentInterestRate");

    const initialState = {
        creditUser: {
            credit_id: "",
            requestedAmount: "",
            approvedQuota: "200000",
            termInDays: vence2,
            totalToPay: calcularTotalAPagar(vence2, cachedTed),
            paydayLimit: dateLimit2,
            documento: "",
            acceptanceDate: "",
            approvedDate: "",
            signatureDate: "",
            status: ""
        },
        datosVarios: {
            deudaHoy: "",
            hasMora: false,
            diasMora: 0,
            statusCredit: "",
            cupoDisponible: ""
        },
        deudaHoyBackend: {}
    }

    const [state, dispatch] = useReducer(CreditUserReducer, initialState);

    // Ref con el valor más reciente de creditUser, para no exigirlo como dependencia
    // del efecto de montaje (solo se lee una vez, al resolver la tasa).
    const creditUserRef = useRef(state.creditUser);
    creditUserRef.current = state.creditUser;

    // Al montar, obtener la tasa del mes actual y recalcular totalToPay
    useEffect(() => {
        getInterest().then(ted => {
            if (ted) {
                dispatch({
                    type: UPDATE_CREDIT_USER,
                    payload: {
                        ...creditUserRef.current,
                        totalToPay: calcularTotalAPagar(vence2, ted)
                    }
                });
            }
        }).catch(console.error);
    }, [vence2, calcularTotalAPagar]);

    const updateCreditUser = useCallback((data) => {

        dispatch({
            type: UPDATE_CREDIT_USER,
            payload: data
        })
    }, []);

    const updateDatosVarios = useCallback((data) => {

        dispatch({
            type: UPDATE_DATOS_VARIOS,
            payload: data
        })
    }, []);

    const updateDeudaHoyBackend = useCallback((data) => {

        dispatch({
            type: UPDATE_DEUDA_HOY_BACKEND,
            payload: data
        })
    }, []);

    return (
        <CreditUserContext.Provider value={
            {
                creditUser: state.creditUser,
                updateCreditUser,
                updateDatosVarios,
                updateDeudaHoyBackend,
                datosVarios: state.datosVarios,
                deudahoyBackend: state.deudaHoyBackend
            }}>
            {props.children}
        </CreditUserContext.Provider>
    )

}


